export default __webpack_public_path__ + "static/media/contaminacion-luminica.3f7b4a60.jpg";